export const CHECK_LOGIN = 'check_login';
export const VERIFY_ADMIN = 'VERIFY_ADMIN';
export const VERIFY_ADMIN_SUCCESS = 'VERIFY_ADMIN_SUCCESS';
export const VERIFY_ADMIN_FAIL = 'VERIFY_ADMIN_FAIL';
export const LOGIN_USER_SUCCESSFUL = 'login_user_successfull';

export const LOGOUT_USER = 'LOGOUT_USER';
export const LOGOUT_USER_SUCCESS = 'LOGOUT_USER_SUCCESS';

export const API_ERROR = 'api_failed';

export const RESET_STATE = 'RESET_STATE';
